import { v4 as generateID } from "uuid";
import combinators from "../constants/combinators.json";

export const defaultGroup = () => ({
    id: generateID(),
    combinator: combinators[0],
    not: false,
    rules: [],
});
